<template>
  <div class="technology-index">
    <TechnologySearch ref="TechnologySearch" v-model="queryParam.materialName" :query-param="queryParam"/>
    <TechnologyNav v-model="queryParam.type"/>
    <TechnologyBanner v-if="queryParam.type === '1'"/>
    <TechnologyTab v-model="queryParam.firstClassify" v-if="queryParam.type === '1'"/>
    <div class="technology-list" :style="backgroundStyle">
      <TechnologySecondTab v-model="queryParam.secondClassify" :first-classify="queryParam.firstClassify"
                           v-if="queryParam.type === '1'" :is-have-image.sync="isHaveImage"/>
      <TechnologyList :query-param="queryParam" ref="TechnologyList" :is-have-image="isHaveImage"/>
    </div>
    <wx-open-launch-weapp
      id="launch-btn"
      appid="wx4b21998b46185f86"
      path="pages/index/index?source=90040010"
    >
      <script type="text/wxtag-template">
        <style>
          .fixed-logo {
            width: 100%;
            height: 100%;
            display: inline-block;
          }
        </style>
        <img src="https://iep.jjmc.cn/bw/file/material/image/1902734850093604960.png" alt="" class="fixed-logo">
      </script>
    </wx-open-launch-weapp>
    <img src="../../assets/images/common/icon-back2.png" alt="" class="icon-back" v-if="isShare" @click.stop="goBack">
  </div>
</template>

<script>
import withRouteTracking from '../../utils/withRouteTracking'
import TechnologySearch from './modules/TechnologySearch'
import TechnologyNav from './modules/TechnologyNav'
import TechnologyBanner from './modules/TechnologyBanner'
import TechnologyTab from './modules/TechnologyTab'
import TechnologySecondTab from './modules/TechnologySecondTab'
import TechnologyList from './modules/TechnologyList'
import {classify} from './data'
import PubSub from 'pubsub-js'

const TechnologyIndex = {
  name: 'technology',
  components: {
    TechnologySearch,
    TechnologyNav,
    TechnologyBanner,
    TechnologyTab,
    TechnologySecondTab,
    TechnologyList
  },
  computed: {
    isShare() {
      return sessionStorage.getItem('isShare')
    },
    backgroundStyle() {
      if (this.queryParam.type === '1') {
        const url = this.classify.find(a => a.value === this.queryParam.firstClassify).listBg
        return {
          backgroundImage: `url(${url})`,
          padding: '25px 15px 20px'
        }
      } else {
        return {
          padding: '0 20px 20px'
        }
      }
    },
  },
  mounted() {
    if (this.$route.query.firstClassify) {
      switch (this.$route.query.firstClassify) {
        case '1':
          this.queryParam.firstClassify = '术式方案'
          break
        case '2':
          this.queryParam.firstClassify = '技术前沿'
          break
        case '3':
          this.queryParam.firstClassify = '专科发展'
          break
        case '4':
          this.queryParam.firstClassify = '诊疗发展'
          break
      }
    } else {
      this.queryParam.firstClassify = this.$route.name
    }
    window.sessionStorage.setItem('traceTitle', `新技术首页-${this.queryParam.firstClassify}`)
    PubSub.subscribe('TechnologySearch', async () => {
      if (this.$refs.TechnologyList) {
        await this.$refs.TechnologyList.resetLoad()
      }
      this.$refs.TechnologySearch.searchLoading = false
    })
  },
  beforeDestroy() {
    PubSub.unsubscribe('TechnologySearch')
  },
  data() {
    return {
      classify,
      queryParam: {
        materialName: '',
        type: '1',
        firstClassify: '技术前沿',
        secondClassify: ''
      },
      isHaveImage: false,
    }
  },
  watch: {
    'queryParam.type': {
      handler(val) {
        if (val === '1') {
          this.queryParam.firstClassify = '技术前沿'
          this.queryParam.secondClassify = ''
        }
        if (val === '2') {
          this.queryParam.firstClassify = undefined
          this.queryParam.secondClassify = undefined
        }
        if (this.$refs.TechnologyList) this.$refs.TechnologyList.resetLoad()
      }
    },
    'queryParam.secondClassify': {
      handler() {
        if (this.$refs.TechnologyList) this.$refs.TechnologyList.resetLoad()
      }
    },
    'queryParam.firstClassify': {
      handler(val) {
        if (!val) {
          this.queryParam.secondClassify = undefined
          return
        }
        let str = ''
        window.sessionStorage.setItem('traceTitle', `新技术首页-${val}`)
        switch (val) {
          case '术式方案':
            str = '1'
            break
          case '技术前沿':
            str = '2'
            break
          case '专科发展':
            str = '3'
            break
          case '诊疗发展':
            str = '4'
            break
        }
        if (this.$route.query && this.$route.query.firstClassify) {
          if (this.$route.query.firstClassify !== str) {
            this.$router.replace({
              path: '/technologyIndex',
              query: {
                firstClassify: str
              }
            })
          }
        }
        const item = this.classify.find(a => a.value === val)
        if (item.children && item.children.length) {
          this.queryParam.secondClassify = item.children[0].value
        } else {
          this.queryParam.secondClassify = undefined
        }
        if (this.$refs.TechnologyList) this.$refs.TechnologyList.resetLoad()
      }
    },
    'queryParam.materialName': {
      handler(val, oldVal) {
        if (oldVal && !val) {
          if (this.$refs.TechnologyList) this.$refs.TechnologyList.resetLoad()
        }
      }
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        path: '/home'
      })
    }
  }
}

export default withRouteTracking(TechnologyIndex)
</script>

<style scoped lang="less">
.technology-index {
  height: 100vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  background: #F7F9FB;
  position: relative;

  .icon-back {
    position: fixed;
    bottom: 125px;
    right: 11px;
    display: block;
    width: 50px;
  }

  #launch-btn {
    position: fixed;
    bottom: 125px;
    left: 11px;
    display: block;
    width: 52px;
    height: 55px;
  }

  .technology-list {
    width: 100%;
    background-repeat: no-repeat;
    background-position: top left;
    box-sizing: border-box;
    background-size: 100%;
    position: relative;
    min-height: 350px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/technology/technology.vue